import { useEffect, useState } from "react";
import "./SelectLoan.scss";

// components
import MainHeader from "../../components/Header/MainHeader";
import CustomButton from "../../components/Button/CustomButton";

import EMIsAPI from "../../services/emi-api";
import { useNavigate } from "react-router-dom";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { googleEvent_LOJ086, googleEvent_LOJ090 } from "../../lib/google-analytics-loan-journey-events";
import { addSelectedLoan } from "../../redux/slices/registerSlice";

export default function SelectLoan() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [appLoading, setAppLoading] = useState(false);

  const { approvalROIViewAPI } = new EMIsAPI();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAPI = async () => {
      const { paydayEMILoanListAPI } = new EMIsAPI();
      const res = await paydayEMILoanListAPI();
      if (res?.status === "1") {
        setData(res.data);

        if (res?.data?.length > 0) {
          setSelectedData(res.data[0]);
        }
      }
      setLoading(false);
    };

    fetchAPI();
  }, []);

  useEffect(() => {
    googleEvent_LOJ086();
  }, []);

  const handleApprovalROIView = async () => {
    dispatch(setStepperDisable(true));
    if(selectedData?.isPL && selectedData?.finbox_required){
      navigate("/finbox-create");
      return;
    }
    // setAppLoading(true);
    // const res = await approvalROIViewAPI(selectedData);
    // if (res.status === "1") {
    //   navigate("/loan-approval", { state: { ...res.data.emi_breakup, product_id: selectedData.ProductID } });
    // }

    // navigate("/loan-approval", { state: { ...selectedData } });
    showManualContextualLoader("Saving your repayment preference…", 1000);
    googleEvent_LOJ090(selectedData, data);
    dispatch(addSelectedLoan(selectedData))
    setTimeout(() => {
      navigate("/loan-approval");
    }, 1000);
  };

  return (
    <>
      <div className="wrapper selectLoan__page">
        <MainHeader title="Select your Loan" />

        <div className="mb-3">
          <p className="label">Please select a repayment option for your loan disbursal</p>
        </div>

        {data?.map((item, index) => (
          <div
            className={`loan-lists ${item.Titel === selectedData?.Titel ? "active" : ""} ${data.length === 1 ? "single" : ""}`}
            key={index}
            onClick={() => {
              setSelectedData(item);

              console.log("item------------", item);
            }}
          >
            <div className="content">
              <h3>{item.Titel}</h3>
              <p>{item.SubTitle}</p>

              <div className="loan-details">
                <div>
                  <p className="value">{item.AmountDetails.Amount}/-</p>
                  <p className="label">{item.AmountDetails.Message}</p>
                </div>
                <div>
                  <p className="value">
                    {item.TenureDetails.Tenure} <span>{item.ProductID === 1 ? "Months" : "Days"}</span>
                  </p>
                  <p className="label">{item.TenureDetails.Message}</p>
                </div>
              </div>
            </div>
            <div className="image">
              <img src={item.Image} alt="" />
            </div>
          </div>
        ))}

        <div className="bottom-button-fixed">
          <CustomButton text="Continue" disabled={selectedData ? false : true} onClick={handleApprovalROIView} />
        </div>
      </div>
    </>
  );
}
